/* istanbul ignore file */
import React, { useState } from 'react';
import { IconMenu } from '@noths/polaris-client-ribbons-design-system';

import { EXPAND_ACCORDION_EVENT_NAME } from '../../../../customEvents';
import { Modal } from '../Modal/Modal';
import { Navigation } from '../Navigation/Navigation';
import * as styles from './StickyHeader.styles';

export const STICKY_HEADER_SPACER_HEIGHT_PX = 106;

interface StickyHeaderProps {
  navItems: {
    title: string;
    id: string;
  }[];
}

export const StickyHeader = ({ navItems }: StickyHeaderProps) => {
  const [modalOpen, setModalOpen] = useState(false);

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const handleNavigationLinkClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    closeModal();

    const accordionID = (e.target as HTMLAnchorElement).hash.replace(/^#/, '');
    const isKeyboardClickEvent = e.detail === 0;

    if (accordionID) {
      document.dispatchEvent(
        new CustomEvent(EXPAND_ACCORDION_EVENT_NAME, {
          detail: {
            focusSummary: isKeyboardClickEvent,
            accordionID,
          },
        }),
      );
    }
  };

  return (
    <>
      <div css={styles.headerSpacer} />
      <header css={styles.header}>
        <div css={[styles.headerInner]}>
          <div css={styles.siteLogo}>
            <a href="/">
              <img
                src="https://images.contentstack.io/v3/assets/blt83ec2ae5e0dbde7f/blt82a5d2de82804125/noths_logo_white.png"
                alt="Not on the high street logo"
              />
            </a>
          </div>

          <button css={styles.burgerMenuButton} onClick={openModal}>
            <IconMenu css={styles.burgerMenuIcon} color="var(--dgg-neutral-white)" />
          </button>
          {modalOpen && (
            <Modal onClose={closeModal}>
              <Navigation onLinkClick={handleNavigationLinkClick} navItems={navItems} />
            </Modal>
          )}
        </div>
      </header>
    </>
  );
};
